import { Icon } from "@blueprintjs/core";

import { TagPill } from "@/components/pieces/roleplays/TagInput";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface TagsListProps {
  tags: Array<{ id: string; name: string; [key: string]: string }>;
  onAddClick?: () => void;
  editable?: boolean;
  showMenu?: boolean;
}

export function TagsList({
  tags,
  onAddClick,
  showMenu,
  editable,
}: TagsListProps) {
  const isEmpty = tags.length === 0;

  if (isEmpty) {
    return (
      <div
        style={{ border: "dashed 1px #E2E2E2" }}
        className="flex flex-col items-center justify-center gap-2.5 rounded-md border border-dashed border-neutral-300 py-6"
      >
        <div className="flex max-w-md flex-col items-center gap-2">
          <p className="text-center text-base leading-[1.6] text-[#2E3C47]">
            Add tags to help others find and understand what this collection is
            about
          </p>
          <button
            onClick={onAddClick ?? (() => {})}
            className="flex items-center gap-2 rounded-lg text-sm leading-[1.714] font-semibold text-[#3788EE]"
          >
            <Icon icon="plus" size={20} />
            Add tags
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex flex-1 flex-wrap items-center gap-2">
        {tags.map((tag) => {
          return <TagPill key={tag.id} tag={tag} allowRemove={false} />;
        })}
      </div>
      {showMenu && editable && (
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger>
            <Icon icon="more" size={16} />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem onClick={onAddClick}>Edit Tags</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
